module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f3cd3bde88a384bf6757c9f30508cdd6.svg";